import { render } from "./Documentation.vue?vue&type=template&id=d6ec23a6&scoped=true"
const script = {}

import "./Documentation.vue?vue&type=style&index=0&id=d6ec23a6&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ec23a6"]])

export default __exports__